export default function IsAuthenticated(to, from, next) {
  const user = localStorage.getItem('storyPhonesUser');
  return (user !== null) ? next() : next('/');
}
